<p-panel [header]="'Item_Details' | translateWF: 'Item Details'">
  <p-card data-variant="compact">
    <p-table [value]="itemDetailsFormGroups().controls" class="w-full" [tableStyle]="{ width: '100%' }" styleClass="w-full">
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'Item' | translateWF: 'Item' }}</th>
          <th>{{ 'Quantity' | translateWF: 'Quantity' }}</th>
          <th>
            {{ 'Unit of Measurement' | translateWF: 'Unit of Measurement' }}
          </th>
          <th>{{ 'Scaling Method' | translateWF: 'Scaling Method' }}</th>
          @if (canEdit()) {
            <th></th>
          }
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row let-i="rowIndex">
        <tr [formGroup]="row">
          <td>
            <p-autoComplete
              formControlName="item"
              [forceSelection]="true"
              [dropdown]="canEdit()"
              #itemMasterSearch="cslServerSearch"
              [cslServerSearch]="fetchItemMasters"
              [suggestions]="itemMasterSearch.results()"
              optionLabel="itemDisplayNameLocalized"
              appendTo="body"
              [readonly]="!canEdit()"
              [styleClass]="!canEdit() ? 'p-disabled' : ''"
            >
              <ng-template let-item pTemplate="item">
                {{ getItemDisplayName(item) }}
              </ng-template>
              <ng-template let-item pTemplate="selectedItem">
                {{ getItemDisplayName(item) }}
              </ng-template>
            </p-autoComplete>
          </td>
          <td>
            <p-inputNumber [minFractionDigits]="2" [maxFractionDigits]="5" formControlName="quantity" [readonly]="!canEdit()" [styleClass]="!canEdit() ? 'p-disabled' : ''" />
          </td>
          <td>
            <p-select
              formControlName="ingredientUnit"
              [options]="ingredientUnitOptions()"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              [readonly]="!canEdit()"
              [styleClass]="!canEdit() ? 'p-disabled' : ''"
            />
          </td>
          <td>
            <p-select
              formControlName="scalingMethod"
              [options]="scalingMethodOptions()"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              [readonly]="!canEdit()"
              [styleClass]="!canEdit() ? 'p-disabled' : ''"
            />
          </td>
          @if (canEdit()) {
            <td>
              <p-button icon="pi pi-trash" (click)="removeElement(i)" />
            </td>
          }
        </tr>
      </ng-template>

      <ng-template pTemplate="footer" *ngIf="canEdit()">
        <tr>
          <td colspan="5" class="p-0">
            <div class="flex w-full justify-end">
              <p-button label="{{ 'Add_Item' | translateWF: 'Add Item' }}" icon="pi pi-plus" variant="outlined" (click)="addElement()" />
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
</p-panel>
